import btnImg from '@assets/web-v3-images/btn-nodata.png';
import { Text } from '@radix-ui/themes';
import bgMuiltiple from '@assets/web-v3-images/btn-buy.png';

export default function Buttons({ handleClick, textBtn, classItem, classItemText, disabled }) {
	return (
		<button
			className={`relative w-full max-w-[100%] mt-[4%] mb-[10%] outline-none btn-click-active
				${disabled ? "opacity-70 !cursor-not-allowed" : ""}
				${classItem}`}
			onClick={disabled ? undefined : handleClick}
			disabled={disabled}
		>
			<img
				src={btnImg}
				className="block w-full h-auto"
				alt="Revive"
			/>

			<Text
				className={`absolute inset-0 flex items-center justify-center text-lg sm:text-2xl md:text-3xl lg:text-3xl xl:text-3xl font-extrabold text-white ${classItemText}`}
				style={{
					WebkitTextStroke: "1px #FF692E",
					paintOrder: "stroke fill",
				}}
			>
				{textBtn}
			</Text>
		</button>
	)
}


export function MuiltipleButtons({ handleClick, textBtn, classItem }) {
	return (
		<button className={`relative w-full cursor-pointer btn-click-active max-w-[100%] mt-[4%] mb-[10%] outline-none ${classItem}`}
			onClick={handleClick}
		>
			<img
				src={bgMuiltiple}
				className="block bg-btn-component-buttons"
				alt="Revive"
			/>

			<Text
				className="absolute inset-0 flex items-center justify-center text-sm sm:text-lg   font-extrabold text-white"
				style={{
					WebkitTextStroke: "1px #FF692E",
					paintOrder: "stroke fill",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					top: "50%",
					transform: "translateY(-50%)",
				}}
			>
				{textBtn}
			</Text>
		</button>
	)
}
